import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import ThemeProvider from 'components/Theme';
import Home from 'components/Home/Home';
// import Lives from 'components/Lives/Lives';
// import LivePlayer from 'components/Lives/LivePlayer';
import BrowserBarrier from 'components/UI/BrowserBarrier/BrowserBarrier';

import Contact from 'components/Contact/Contact';
import Medias from 'components/Medias/Medias';
// import Help from 'components/Help/Help';
// import Agenda from 'components/Agenda/Agenda';
import DetectBrowser from 'components/UI/DetectBrowser/DetectBrowser';
import Account from 'components/Account/Account';
import AdminAccount from 'components/UI/Account/AdminAccount';
import AdminNews from 'components/UI/News/AdminNews';
import AdminUtm from "components/UI/Utm/AdminUtm";

import AdminCMS from 'components/UI/Cms/AdminCms';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import NoMatch from 'components/NoMatch';
import Logout from 'components/Logout';
import Login from 'components/Login/Login';
import Registration from 'components/Registration/Registration';
import Legal from 'components/Legal/Legal';
import Confidentiality from 'components/Confidentiality/Confidentiality';
// import HomeSubscribe from "./HomeSubscribe";
import { ResetPasswordRequest, ResetPasswordChallenge } from 'components/UI/ResetPassword';
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  getCurrentUserRole,
  // isLoggedIn,
} from '../ducks/authentication';
import queryString from 'query-string';
import properCase from 'mout/string/properCase';

import PWAPrompt from 'react-ios-pwa-prompt'

// import capitalize from "lodash/capitalize";
import '../App.scss';

const styles = (theme) => {
  return {
    root: {
      // backgroundImage: `url(${require('assets/images/' + process.env.REACT_APP_SITE + '/background.jpg')})`,
      // backgroundPosition: '0 0',
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat',
      [theme.breakpoints.down('sm')]: {
        // backgroundPosition: '0 0',
      },
    },
  };
};

class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // document.title = 'Canal ' + properCase(process.env.REACT_APP_SITE);
    this.props.onMount();
  }
  render() {
    const {
      // loggedIn,
      userRole,
      authStateKnown,
      classes,
      // width,
      // $$data
    } = this.props;
    // console.log({authStateKnown})
    return (
      <div className={classes.root}>
        <ThemeProvider>
          <CssBaseline />
          <ScrollToTopOnMount />
          <DetectBrowser />
          <If condition={authStateKnown === true}>
            <BrowserBarrier />
            <PWAPrompt
              copyTitle={"Ajouter à l'écran d'accueil"}
              copyBody={"Ce site à le fonctionnement d'une WebApp. Ajoutez le à votre écran d'accueil pour y accéder hors connextion !"}
              copyShareButtonLabel={'1) Appuyez sur le bouton "Partager"'}
              copyAddHomeButtonLabel={"2) Appuyez sur ajouter \"Sur l'écran d'accueil\""}
              copyClosePrompt={'Annuler'}
              promptOnVisit={1} timesToShow={3}
              permanentlyHideOnDismiss={false}
              />

            <Router>
              <Switch>
                <Route exact path={'/'} component={({ match }) => <Home />} />
                {/* <Route
                  exact
                  path={"/subscribe"}
                  component={({ match }) => <Home subscribe={true} />}
                  /> */}
                  <Route exact path={'/registration'} component={({ match }) => <Registration />} />
                  <Route
                    exact={true}
                    path={'/subscribe/:id'}
                    component={({ match }) => <Home subscribe={true} themeId={match.params.id} />}
                    />
                  <Route exact path={'/login'} component={({ match }) => <Login />} />
                  <Route exact path={'/help'} component={({ match }) => <Help />} />
                  <Route exact path={'/contact'} component={({ match }) => <Contact />} />
                  <Route path={'/legal'} component={() => <Legal />} />
                  <Route path={'/confidentiality'} component={() => <Confidentiality />} />
                  <Route exact path={'/logout'} component={() => <Logout />} />
                  <Route path="/rpwd" component={({ match }) => <ResetPasswordRequest match={match} />} />
                  <Route path="/cpwd" component={() => <ResetPasswordChallenge />} />
                  <Route
                    path="/staff/account/:action/:id"
                    component={({ match }) => <AdminAccount match={match} />}
                    />
                  <Route
                    path="/staff/account/:action"
                    component={({ match }) => <AdminAccount match={match} />}
                    />
                  <Route path="/staff/account" component={() => <AdminAccount />} />

                  <Route
                    path="/staff/event/:action/:id"
                    component={({ match }) => <AdminEvent match={match} />}
                    />
                  <Route path="/staff/news/:action/:id" component={({ match }) => <AdminNew match={match} />} />
                  <Route path="/staff/news/:action" component={({ match }) => <AdminNews match={match} />} />

                  <Route path="/staff/faq/:action/:id" component={({ match }) => <AdminFaq match={match} />} />
                  <Route path="/staff/faq/:action" component={({ match }) => <AdminFaq match={match} />} />



                    <Route
                      path="/staff/utm/:action/:id"
                      component={({ match }) => <AdminUtm match={match} />}
                      />
                    <Route path="/staff/utm/:action" component={({ match }) => <AdminUtm match={match} />} />
                    <Route path="/staff/utm" component={() => <AdminUtm />} />


                  <Route path="/staff/cms/:action/:id" component={({ match }) => <AdminCMS match={match} />} />
                  <Route path="/staff/cms/:action" component={({ match }) => <AdminCMS match={match} />} />

                  <Route path="/account" component={({ match }) => <Account match={match} />} />
                  <Route component={() => <NoMatch />} />
                </Switch>
              </Router>
            </If>
          </ThemeProvider>
        </div>
      );
    }
  }

  function mapStateToProps(state) {
    const props = {
      authStateKnown: authStateKnown(state),
      // loggedIn: isLoggedIn(state),
      userRole: getCurrentUserRole(state),
    };
    return props;
  }
  function mapDispatchToProps(dispatch) {
    return {
      onMount: () => {
        const uri = queryString.parse(window.location.search);

        return dispatch(initialeLogin({ referer: uri.r }));
      },
    };
  }

  export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js